// @flow

export const isProd = process.env.NODE_ENV === 'production';
export const WEB_PORT = process.env.PORT || 8000;

export const IMAGE_PATH = isProd
  ? 'https://images.expeditiondata.com'
  : 'https://images-dev.thehiringengine.com';
export const APP_NAME = 'Team Engine';
export const WIZARD_FORM_NAME = 'WizardPageForm';

export const DOMAIN = isProd
  ? 'apply.teamengine.io'
  : `local.apply.expeditiondata.com:${WEB_PORT}`;
